import React from 'react';

// import services data
import { services } from '../data';
import RubberBand from 'react-reveal/RubberBand';
import { Flip } from 'react-reveal';
import { Helmet } from 'react-helmet';

const Services = () => {
  return (
    <section id='services' className='section bg-tertiary'>
      <Helmet>
        <title>Full Stack Web Developer Nahid | React, Next.js, MERN Stack Development</title>
        <meta name="description" content="Expert Full Stack Web Developer specializing in MERN Stack, React, Next.js, and custom web solutions. Get your responsive, scalable, and dynamic websites developed by Nahid." />
        <meta name="keywords" content="full stack developer, web development, React, Next.js, MERN, custom website development, responsive websites, web solutions, web developer Nahid, Bangladesh web development" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <Flip>
            <h2 className='section-title before:content-services relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-28 before:hidden before:lg:block'>
              What I do for clients
            </h2>
            <p className='subtitle text-xl text-white'>
              Passionate about building scalable, responsive, and dynamic websites tailored to your business needs.
            </p>
          </Flip>
        </div>
        <div className='grid lg:grid-cols-3 gap-8'>
          {services.map((service, index) => {
            const { icon, name, description } = service;
            return (
              <div className='bg-secondary p-6 rounded-2xl border border-transparent hover:border-accent hover:-translate-y-4 hover:text-accent hover:duration-150' key={index}>
                <RubberBand>
                  <div className='text-accent rounded-sm w-12 h-12 flex justify-center items-center mb-12 text-6xl'>
                    {icon}
                  </div>
                  <h4 className='text-xl font-medium mb-2 '>{name}</h4>
                  <p>{description}</p>
                </RubberBand>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
